<div *ngIf="hasAccess(['ADMIN'])">
  <app-admin-header></app-admin-header>
</div>
<div *ngIf="hasAccess(['MDA'])">
  <app-mda-header></app-mda-header>
</div>
<div class="user-mgt-bg">
  <div class="container">
    <h6 class="ms-2 mt-4 mb-3">
      <b>Taxpayers Management Page</b>
    </h6>
    <div class="row mb-3">
      <div class="col-md-9">
        <div class="row">
          <div class="col-md-3 col-xs-4">
            <div class="me-2 small-card-primary">
              <p>{{ userCounts?.companyCount | number }}</p>
            </div>
          </div>
          <div class="col-md-3 col-xs-4">
            <div class="me-2 small-card-success">
              <p>{{ userCounts?.individualCount | number }}</p>
            </div>
          </div>
          <div class="col-md-3 col-xs-4">
            <div class="me-2 small-card-ash">
              <p>{{ userCounts?.informalCount | number }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ms-1 mb-3 top-bar-div">
      <div style="background: #eee">
        <div class="top-buttons">
          <button
            [style.background]="allPayerBg"
            (click)="changeBackgroundColor('')"
          >
            All Users
          </button>
          <button
            [style.background]="individualPayerBg"
            (click)="changeBackgroundColor('USER')"
          >
            Individual
          </button>
          <button
            [style.background]="informalBg"
            (click)="changeBackgroundColor('INFORMAL')"
          >
            Informal
          </button>
          <button
            [style.background]="corporatePayerBg"
            (click)="changeBackgroundColor('COMPANY')"
          >
            Corporate
          </button>
        </div>
      </div>
      <div
        *ngIf="taxGroupSelected == '' || taxGroupSelected == 'MDA'"
        class="app-center"
        style="display: flex; flex-direction: row"
      >
        <small>Filter by status: &nbsp;</small>
        <div
          ngbDropdown
          class="d-inline-block me-3"
          style="justify-content: end"
        >
          <select
            class="text-white text-center selector"
            (change)="filterBySelectedValue($event)"
          >
            <!-- <option value="">All</option> -->
            <option value="ACTIVE">Active</option>
            <option value="INACTIVE">Inactive</option>
            <!-- <option value="LOCKED">Locked</option> -->
          </select>
        </div>

        <form [formGroup]="form" (ngSubmit)="search()" class="form-inline">
          <div
            class="form-group form-group-c input-search-icon"
            style="position: relative"
          >
            <input
              type="text"
              formControlName="searchBy"
              class="form-control search-input mx-4"
              placeholder="Search tax payer"
            />
          </div>
        </form>

        <button type="button" (click)="search()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 23 23"
            fill="none"
          >
            <g clip-path="url(#clip0_8_2951)">
              <path
                d="M13.4599 16.7813C17.2357 15.1766 18.9957 10.815 17.391 7.03929C15.7864 3.26358 11.4247 1.50358 7.64903 3.10821C3.87332 4.71285 2.11332 9.07449 3.71796 12.8502C5.3226 16.6259 9.68423 18.3859 13.4599 16.7813Z"
                stroke="#6B6C7E"
                stroke-width="1.84417"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.8066 15.1964L21.5678 20.9584"
                stroke="#6B6C7E"
                stroke-width="1.84417"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_8_2951">
                <rect
                  width="21.7211"
                  height="22.4862"
                  fill="white"
                  transform="translate(0.8125 0.202759)"
                />
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>

      <div *ngIf="taxGroupSelected == 'USER'" class="right-buttons mt-3">
        <div class="d-flex justify-content-end">
          <button class="custom-search-button" (click)="toggleSearch()">
            Search
            <span class="mdi mdi-magnify custom-search-icon"></span>
          </button>
        </div>
      </div>
      <div
        *ngIf="taxGroupSelected == 'INFORMAL' || taxGroupSelected == 'COMPANY'"
        class="right-buttons mt-3"
      >
        <div class="d-flex justify-content-end">
          <button class="custom-search-button" (click)="toggleCompanySearch()">
            Search
            <span class="mdi mdi-magnify custom-search-icon"></span>
          </button>
        </div>
      </div>
    </div>

    <div class="search-parameters" *ngIf="showCorporateSearch">
      <form class="search-form" [formGroup]="corporateSearchForm">
        <button
          class="btn btn-outline-secondary btn-sm position-absolute top-0 end-0"
          (click)="toggleCompanySearch()"
        >
          <span class="mdi mdi-close"></span>
        </button>
        <div class="row mt-2 mb-3">
          <div class="col-md-3 mt-2">
            <label>Name </label>
            <input
              type="text"
              class="form-control small-option-font"
              formControlName="name"
            />
          </div>

          <div class="col-md-3 mt-2">
            <label>ASIN </label>
            <input
              type="text"
              class="form-control small-option-font"
              formControlName="asin"
            />
          </div>

          <div class="col-md-3 mt-2">
            <label>Phone Number</label>
            <input
              type="text"
              class="form-control small-option-font"
              formControlName="phoneNumber"
            />
          </div>

          <div class="col-md-3 mt-2">
            <label>Email</label>
            <input
              type="text"
              class="form-control small-option-font"
              formControlName="email"
            />
          </div>
          <div class="col-md-3">
            <label>Classification</label>
            <select
              class="form-control small-option-font"
              formControlName="classification"
            >
              <option value="">Select option</option>
              <option
                *ngFor="let classification of businessClassificationList"
                [value]="classification?.name"
              >
                {{ classification?.name }}
              </option>
            </select>

            <!-- <select class="form-control small-option-font" formControlName="classification">
                            <option value="">-- Select Classification --</option>
                            <option value="COMPANY">Company</option>
                            <option value="INCORPORATED_TRUSTEE">Incorporated Trustee</option>
                            <option value="BUSINESS_NAME">Business Name</option>
                            <option value="LIMITED_PARTNERSHIP">Limited Partnership</option>
                            <option value="LIMITED_LIABILITY_PARTNERSHIP">
                                Limited Liability Partnership
                            </option>
                        </select> -->
          </div>

          <div class="col-md-3">
            <label>Nature of Business</label>
            <select
              class="form-control small-option-font"
              formControlName="natureOfBusiness"
            >
              <option value="">Select option</option>
              <option
                *ngFor="let natureOfBusiness of natureOfBusinessList"
                [value]="natureOfBusiness?.name"
              >
                {{ natureOfBusiness?.name }}
              </option>
            </select>
            <!-- <select class="form-control small-option-font" formControlName="natureOfBusiness">
                            <option value="">-- Select Nature of Business --</option>
                            <option value="Uncategorized">Uncategorized</option>
                            <option value="ACTIVITIES OF EXTRATERRITORIAL ORGANISATION AND BODIES">Activities of Extraterritorial Organisations and Bodies</option>
                            <option value="ACTIVITIES OF HOUSE AS EMPLOYMENT UNDIFFERENTIATED GOODS-AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE">Activities of Households as Employers; Undifferentiated Goods- and Services-Producing Activities of Households for Own Use</option>
                            <option value="ACCOMODATION AND FOOD SERVICES ACTIVITIES">Accommodation and Food Services Activities</option>
                            <option value="ART, ENTERTAINMENT AND RECREATION">Art, Entertainment and Recreation</option>
                            <option value="COMMUNITY BASED ASSOCIATION">Community-Based Association</option>
                            <option value="CONSTRUCTION">Construction</option>
                            <option value="CULTURAL BASED ASSOCIATION">Cultural-Based Association</option>
                            <option value="EDUCATION">Education</option>
                            <option value="FAITH BASED ASSOCIATION">Faith-Based Association</option>
                            <option value="FINANCIAL AND INSURANCE ACTIVITIES">Financial and Insurance Activities</option>
                            <option value="FOUNDATION BASED ASSOCIATION">Foundation-Based Association</option>
                            <option value="HUMAN HEALTH AND SOCIAL WORK ACTIVITIES">Human Health and Social Work Activities</option>
                            <option value="INFORMATION AND COMMUNICATION">Information and Communication</option>
                            <option value="MANUFACTURING">Manufacturing</option>
                            <option value="MINING AND QUARRYING">Mining and Quarrying</option>
                            <option value="OTHER ACTIVITIES OF EXTRA-TERRITORIAL ORGANIZATION AND BODIES">Other Activities of Extraterritorial Organisations and Bodies</option>
                            <option value="OTHER SERVICE ACTIVITIES">Other Service Activities</option>
                            <option value="POWER">Power</option>
                            <option value="PROFESSIONAL,SCIENTIFIC AND TECHNICAL ACTIVITIES">Professional, Scientific and Technical Activities</option>
                            <option value="PUBLIC ADMINISTRATION AND DEFENCE;DEFENCE, COMPULSORY SOCIAL SECURITY">Public Administration and Defence; Defence, Compulsory Social Security</option>
                            <option value="REPAIRS OF MOTORVEHICLES AND MOTORCYCLES">Repairs of Motor Vehicles and Motorcycles</option>
                            <option value="REAL ESTATE ACTIVITIES">Real Estate Activities</option>
                            <option value="SOCIAL CLUBS BASED ASSOCIATION">Social Clubs-Based Association</option>
                            <option value="SPORTING BASED ASSOCIATION">Sporting-Based Association</option>
                            <option value="TRANSPORTATION">Transportation</option>
                            <option value="WATERSUPPLY,SEWERAGE,WASTEMANAGEMENT AND REMEDIATION ACTIVITIES">Watersupply, Sewerage, Waste Management and Remediation Activities</option>
                            <option value="WHOLESALE AND RETAIL TRADE;REPAIR OF MOTOR VEHICLES AND MOTOR VEHICLES AND MOTORCYCLES">Wholesale and Retail Trade; Repair of Motor Vehicles and Motorcycles</option>

                        </select> -->
          </div>

          <div class="col-md-3">
            <label>Business Premises Profiling Status</label>

            <select
              class="form-control small-option-font"
              formControlName="businessPremisesProfiled"
            >
              <option value="">-- Select Status --</option>
              <option value="yes">Profiled</option>
              <option value="no">Not Profiled</option>
            </select>
          </div>

          <div class="col-md-3">
            <label>Fire Service Profiling Status</label>

            <select
              class="form-control small-option-font"
              formControlName="fireServiceProfiled"
            >
              <option value="">-- Select Status --</option>
              <option value="yes">Profiled</option>
              <option value="no">Not Profiled</option>
            </select>
          </div>

          <div class="col-md-3">
            <label>Local Govt.</label>
            <select class="form-control small-option-font" formControlName="lg">
              <option value="">-- Select Local Govt. --</option>
              <option *ngFor="let lga of lgaList" [value]="lga?.id">
                {{ lga?.name }}
              </option>
            </select>
          </div>

          <div class="col-md-3 mt-2">
            <label>From </label>
            <input
              type="date"
              class="form-control small-option-font"
              formControlName="from"
            />
          </div>

          <div class="col-md-3 mt-2">
            <label>To </label>
            <input
              type="date"
              class="form-control small-option-font"
              formControlName="to"
            />
          </div>

          <div class="col-md-3 col-sm-9">
            <button
              class="btn btn-sm search-button"
              (click)="search(); toggleCompanySearch()"
            >
              Search
            </button>
          </div>
          <div class="col-md-3 mt-2 col-sm-9">
            <button
              class="btn btn-sm reset-button small-option-font"
              (click)="resetForm()"
              type="submit"
            >
              Reset
            </button>
          </div>
        </div>
      </form>
    </div>

    <div class="search-parameters" *ngIf="showIndividualSearch">
      <form class="search-form" [formGroup]="individualSearchForm">
        <button
          class="btn btn-outline-secondary btn-sm position-absolute top-0 end-0"
          (click)="toggleSearch()"
        >
          <span class="mdi mdi-close"></span>
        </button>
        <div class="row mt-2 g-3 gy-2 mb-3">
          <div class="col-md-3 mt-2">
            <label>Name </label>
            <input
              type="text"
              class="form-control small-option-font"
              formControlName="name"
            />
          </div>

          <div class="col-md-3 mt-2">
            <label>ASIN </label>
            <input
              type="text"
              class="form-control small-option-font"
              formControlName="asin"
            />
          </div>

          <div class="col-md-3 mt-2">
            <label>Phone Number</label>
            <input
              type="text"
              class="form-control small-option-font"
              formControlName="phoneNumber"
            />
          </div>

          <div class="col-md-3 mt-2">
            <label>Email</label>
            <input
              type="text"
              class="form-control small-option-font"
              formControlName="email"
            />
          </div>
          <div class="col-md-3">
            <label>Presumptive Profiling Status</label>

            <select
              class="form-control small-option-font"
              formControlName="presumptiveProfiled"
            >
              <option value="">-- Select Status --</option>
              <option value="yes">Profiled</option>
              <option value="no">Not Profiled</option>
            </select>
          </div>

          <div class="col-md-3">
            <label>Local Govt.</label>
            <select class="form-control small-option-font" formControlName="lg">
              <option value="">-- Select Local Govt. --</option>
              <option *ngFor="let lga of lgaList" [value]="lga?.id">
                {{ lga?.name }}
              </option>
            </select>
          </div>

          <div class="col-md-3 mt-2">
            <label>From </label>
            <input
              type="date"
              class="form-control small-option-font"
              formControlName="from"
            />
          </div>

          <div class="col-md-3 mt-2">
            <label>To </label>
            <input
              type="date"
              class="form-control small-option-font"
              formControlName="to"
            />
          </div>

          <div class="col-md-3">
            <label>NIN Status</label>

            <select
              class="form-control small-option-font"
              formControlName="hasNIN"
            >
              <option value="">-- Select NIN Status --</option>
              <option value="true">Has NIN</option>
              <option value="false">Does Not Have NIN</option>
            </select>
          </div>

          <div class="col-md-3 mt-2">
            <label>NIN </label>
            <input
              type="text"
              maxlength="15"
              class="form-control small-option-font"
              formControlName="nin"
            />
          </div>

          <div class="col-md-3 col-sm-9">
            <button
              class="btn btn-sm search-button"
              (click)="search(); toggleSearch()"
            >
              Search
            </button>
          </div>
          <div class="col-md-3 mt-2 col-sm-9 d-flex flex-column justify-content-end">
            <button
              class="btn btn-sm reset-button mt-auto small-option-font"
              (click)="resetForm()"
              type="submit"
            >
              Reset
            </button>
          </div>
        </div>
      </form>
    </div>

    <div class="ms-1 bg-white p-5 mb-5">
      <table
        class="table table-hover table-responsive table-bordered table-striped"
      >
        <thead class="table-dark">
          <tr>
            <th class="user-type-th text-white">USER</th>
            <th class="text-white">FULL NAME</th>
            <th *ngIf="taxGroupSelected != 'MDA'" class="text-white">ASIN</th>
            <th class="text-white">NIN</th>
            <th class="text-white">EMAIL</th>
            <th class="text-white">PHONE NO</th>
            <th *ngIf="taxGroupSelected == 'MDA'" class="text-white">
              TAX OFFICE
            </th>
            <th *ngIf="taxGroupSelected == 'MDA'" class="text-white">ROLE</th>
            <th class="text-white">ADDRESS</th>
            <th class="text-white">STATUS</th>
            <th class="text-white">ACTION</th>
          </tr>
        </thead>

        <tbody *ngIf="!isSearching && details?.length > 0">
          <tr *ngFor="let eachDetail of details; let i = index">
            <td class="user-type-td">
              <b class="rounded">
                <img
                  class="photo-content-img"
                  *ngIf="eachDetail.photo"
                  [src]="eachDetail.photo"
                  alt="image"
                />
                {{
                  eachDetail.photo
                    ? ""
                    : extractFirstAlphabets(eachDetail.displayname)
                }}
              </b>
            </td>
            <td>
              <b>{{ eachDetail?.displayname | uppercase }}</b>
            </td>
            <td *ngIf="taxGroupSelected != 'MDA'">
              {{ eachDetail?.tinNumber | uppercase }}
            </td>
            <td>
              {{ eachDetail?.nin || '--'| uppercase }}
            </td>
            <td>{{ eachDetail?.email | lowercase }}</td>
            <td>{{ eachDetail?.phoneNumber | uppercase }}</td>
            <td *ngIf="taxGroupSelected == 'MDA'">
              {{ eachDetail?.taxOfficeName | uppercase }}
            </td>
            <td *ngIf="taxGroupSelected == 'MDA'">
              {{ eachDetail?.role | removeUnderscores | uppercase }}
            </td>
            <td>{{ eachDetail?.address | uppercase }}</td>
            <td (click)="confirmStatusChange(eachDetail?.userId, eachDetail.status, eachDetail.displayname)">
              <small
                [ngClass]="{
                  'active-status': eachDetail?.status === 'ACTIVE',
                  'inactive-status': eachDetail?.status === 'INACTIVE',
                  'default-status':
                    eachDetail?.status !== 'ACTIVE' &&
                    eachDetail?.status !== 'INACTIVE',
                }"
                >{{ eachDetail?.status | uppercase }}</small
              ><b *ngIf="eachDetail?.nonLocked == false"> 🔒</b>
            </td>
            <td class="user-type-td">
              <div ngbDropdown class="d-inline">
                <button
                  class="btn btn-secondary btn-sm btn-flat"
                  id="dropdownBasic1"
                  ngbDropdownToggle
                  type="button"
                >
                  Available Actions
                </button>
                <div
                  ngbDropdownMenu
                  aria-labelledby="dropdownBasic1"
                  class="dropdown-menu-flat"
                >
                  <a
                    *ngIf="taxGroupSelected != 'MDA'"
                    (click)="viewProfile(eachDetail?.tinNumber)"
                    style="
                      font-family: Inter;
                      font-size: 14px;
                      font-style: normal;
                    "
                    ngbDropdownItem
                    class="dropdown-item-flat"
                  >
                    View Profile
                  </a>
                  <a
                    *ngIf="
                      hasAccess([
                        'ALL_PERMISSIONS',
                        'CAN_EDIT_TAXPAYER_PROFILE',
                      ])
                    "
                    (click)="
                      edit(eachDetail.userId, eachDetail?.displayname);
                      getUserDetails();
                      open(edit_modal)
                    "
                    style="
                      font-family: Inter;
                      font-size: 14px;
                      font-style: normal;
                    "
                    ngbDropdownItem
                    class="dropdown-item-flat"
                  >
                    Edit Profile
                  </a>

                  <a
                    *ngIf="
                      taxGroupSelected == 'MDA' &&
                      hasAccess([
                        'ALL_PERMISSIONS',
                        'CAN_CHANGE_ADMIN_PASSWORD',
                      ])
                    "
                    (click)="
                      edit(eachDetail.userId, eachDetail?.displayname);
                      openPassword(reset_password_modal)
                    "
                    style="
                      font-family: Inter;
                      font-size: 14px;
                      font-style: normal;
                    "
                    ngbDropdownItem
                    class="dropdown-item-flat"
                  >
                    Change Password
                  </a>
                  <a
                    *ngIf="
                      taxGroupSelected != 'MDA' &&
                      (eachDetail?.taxgroup == 'USER' ||
                        eachDetail?.taxgroup == 'INFORMAL' ||
                        eachDetail?.taxgroup == 'COMPANY' ||
                        eachDetail?.role == 'INDIVIDUAL' ||
                        eachDetail?.role == 'CORPORATE')
                    "
                    (click)="
                      printAsinCard(
                        eachDetail?.taxgroup || taxGroupSelected,
                        eachDetail?.tinNumber
                      )
                    "
                    style="
                      font-family: Inter;
                      font-size: 14px;
                      font-style: normal;
                    "
                    ngbDropdownItem
                    class="dropdown-item-flat"
                  >
                    Print ASIN Card
                  </a>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="pagination">
        <ngb-pagination
          *ngIf="!isSearching && details?.length > 0"
          class="d-flex justify-content-center my-3"
          [page]="currentPage"
          (pageChange)="onPageChange($event)"
          [maxSize]="5"
          [pageSize]="pageSize"
          [collectionSize]="count"
          [boundaryLinks]="true"
          [directionLinks]="true"
          [rotate]="true"
        ></ngb-pagination>
      </div>

      <div class="d-flex justify-content-center mt-3">
        <p *ngIf="isSearching" class="text-muted">Please wait...</p>
        <p *ngIf="isEmpty" class="text-danger">No User found</p>
      </div>
    </div>

    <ng-template #edit_modal let-c="close" let-d="dismiss">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
          Edit {{ userDisplayName | titlecase }}'s Account
        </h4>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="d('Cross click')"
        >
          <img src="assets/img/icon_cancel.png" alt="close icon" />
        </button>
      </div>
      <div class="modal-body">
        <form
          *ngIf="
            taxGroupSelected == 'COMPANY' || taxGroupSelected == 'INFORMAL'
          "
          class="row personal-form"
          [formGroup]="editCompanyForm"
        >
          <div class="col-md-6">
            <div class="form-group mb-2">
              <label>Company Name <span class="text-danger">*</span></label>
              <input
                formControlName="corporateName"
                type="text"
                class="form-control"
                placeholder="Company Name"
                readonly
              />
              <div
                *ngIf="
                  editCompanyForm.get('corporateName')?.hasError('required') &&
                  editCompanyForm.get('corporateName')?.touched
                "
              >
                <small class="text-danger">Company Name is required.</small>
              </div>
            </div>

            <div class="form-group mb-2">
              <label>Email <span class="text-danger">*</span></label>
              <input
                formControlName="email"
                type="email"
                class="form-control"
                placeholder="axxxxx@gmail.com"
                readonly
              />
            </div>

            <div class="form-group mb-2">
              <label>Nature of Business</label>
              <select class="form-control" formControlName="natureOfBusiness">
                <option default>{{ companyDetails?.natureOfBusiness }}</option>
                <option value="">-- Select Nature of Business --</option>
                <option
                  value="ACTIVITIES OF EXTRATERRITORIAL ORGANISATION AND BODIES"
                >
                  Activities of Extraterritorial Organisations and Bodies
                </option>
                <option
                  value="ACTIVITIES OF HOUSE AS EMPLOYMENT UNDIFFERENTIATED GOODS-AND SERVICES-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE"
                >
                  Activities of Households as Employers; Undifferentiated Goods-
                  and Services-Producing Activities of Households for Own Use
                </option>
                <option value="ACCOMODATION AND FOOD SERVICES ACTIVITIES">
                  Accommodation and Food Services Activities
                </option>
                <option value="ART, ENTERTAINMENT AND RECREATION">
                  Art, Entertainment and Recreation
                </option>
                <option value="COMMUNITY BASED ASSOCIATION">
                  Community-Based Association
                </option>
                <option value="CONSTRUCTION">Construction</option>
                <option value="CULTURAL BASED ASSOCIATION">
                  Cultural-Based Association
                </option>
                <option value="EDUCATION">Education</option>
                <option value="FAITH BASED ASSOCIATION">
                  Faith-Based Association
                </option>
                <option value="FINANCIAL AND INSURANCE ACTIVITIES">
                  Financial and Insurance Activities
                </option>
                <option value="FOUNDATION BASED ASSOCIATION">
                  Foundation-Based Association
                </option>
                <option value="HUMAN HEALTH AND SOCIAL WORK ACTIVITIES">
                  Human Health and Social Work Activities
                </option>
                <option value="INFORMATION AND COMMUNICATION">
                  Information and Communication
                </option>
                <option value="MANUFACTURING">Manufacturing</option>
                <option value="MINING AND QUARRYING">
                  Mining and Quarrying
                </option>
                <option
                  value="OTHER ACTIVITIES OF EXTRA-TERRITORIAL ORGANIZATION AND BODIES"
                >
                  Other Activities of Extraterritorial Organisations and Bodies
                </option>
                <option value="OTHER SERVICE ACTIVITIES">
                  Other Service Activities
                </option>
                <option value="POWER">Power</option>
                <option
                  value="PROFESSIONAL,SCIENTIFIC AND TECHNICAL ACTIVITIES"
                >
                  Professional, Scientific and Technical Activities
                </option>
                <option
                  value="PUBLIC ADMINISTRATION AND DEFENCE;DEFENCE, COMPULSORY SOCIAL SECURITY"
                >
                  Public Administration and Defence; Defence, Compulsory Social
                  Security
                </option>
                <option value="REPAIRS OF MOTORVEHICLES AND MOTORCYCLES">
                  Repairs of Motor Vehicles and Motorcycles
                </option>
                <option value="REAL ESTATE ACTIVITIES">
                  Real Estate Activities
                </option>
                <option value="SOCIAL CLUBS BASED ASSOCIATION">
                  Social Clubs-Based Association
                </option>
                <option value="SPORTING BASED ASSOCIATION">
                  Sporting-Based Association
                </option>
                <option value="TRANSPORTATION">Transportation</option>
                <option
                  value="WATERSUPPLY,SEWERAGE,WASTEMANAGEMENT AND REMEDIATION ACTIVITIES"
                >
                  Watersupply, Sewerage, Waste Management and Remediation
                  Activities
                </option>
                <option
                  value="WHOLESALE AND RETAIL TRADE;REPAIR OF MOTOR VEHICLES AND MOTOR VEHICLES AND MOTORCYCLES"
                >
                  Wholesale and Retail Trade; Repair of Motor Vehicles and
                  Motorcycles
                </option>
              </select>
            </div>
            <div class="form-group mb-2">
              <label>RC. Number</label>
              <input
                formControlName="rcNumber"
                type="text"
                class="form-control"
                placeholder="32xxxxx"
                readonly
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-2">
              <label>Mobile Number <span class="text-danger">*</span></label>
              <input
                formControlName="phoneNumber"
                type="text"
                class="form-control"
                placeholder="Mobile Number"
                readonly
              />
              <div
                *ngIf="editCompanyForm.get('phoneNumber')?.hasError('required')"
              >
                <small class="text-danger">Mobile Number is required</small>
              </div>
              <div
                *ngIf="
                  editCompanyForm
                    .get('phoneNumber')
                    ?.hasError('invalidPhoneNumber')
                "
              >
                <small class="text-danger">Invalid phone number format</small>
              </div>
            </div>

            <div class="form-group mb-2">
              <label>Address <span class="text-danger">*</span></label>
              <input
                formControlName="address"
                type="text"
                class="form-control"
                placeholder="5, xxxxx, Estate..."
              />
              <div
                *ngIf="
                  editCompanyForm.get('address')?.hasError('required') &&
                  editCompanyForm.get('address')?.touched
                "
              >
                <small class="text-danger">Address is required.</small>
              </div>
            </div>

            <div class="form-group mb-2">
              <label>Classification</label>
              <select class="form-control" formControlName="classification">
                <option default>{{ companyDetails?.classification }}</option>
                <option value="BUSINESS_NAME">Business Name</option>
                <option value="COMPANY">Company</option>
                <option value="INCORPORATED_TRUSTEE">
                  Incorporated Trustee
                </option>
                <option value="LIMITED_PARTNERSHIP">Limited Partnership</option>
                <option value="LIMITED_LIABILITY_PARTNERSHIP">
                  Limited Liability Partnership
                </option>
              </select>
            </div>

            <div class="form-group mt-3">
              <label>LGA</label>
              <select class="form-control" formControlName="lgaId">
                <option default>
                  {{ companyDetails?.lgaName | uppercase }}
                </option>
                <option [value]="lga?.id" *ngFor="let lga of lgaList">
                  {{ lga?.name }}
                </option>
              </select>
            </div>
          </div>
        </form>

        <!-- 
    COMPANY FORM STOPS HERE
    -->

        <!-- 
    ADMIN FORM STARTS HERE
    -->

        <form
          *ngIf="taxGroupSelected == 'MDA'"
          class="row personal-form"
          [formGroup]="editAdminForm"
        >
          <div class="personal-form">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label>First name</label>
                  <input
                    formControlName="firstName"
                    type="text"
                    class="form-control"
                    placeholder="First Name"
                    readonly
                  />
                  <div
                    *ngIf="
                      editAdminForm.get('firstName')?.hasError('required') &&
                      editAdminForm.get('firstName')?.touched
                    "
                  >
                    <small class="text-danger">First name is required.</small>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label>Last name</label>
                  <input
                    formControlName="lastName"
                    type="text"
                    class="form-control"
                    placeholder="Last name"
                    readonly
                  />
                  <div
                    *ngIf="
                      editAdminForm.get('lastName')?.hasError('required') &&
                      editAdminForm.get('lastName')?.touched
                    "
                  >
                    <small class="text-danger">Last Name is required.</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label>Email</label>
                  <input
                    formControlName="email"
                    type="email"
                    class="form-control"
                    placeholder="axxxxx@gmail.com"
                    readonly
                  />
                  <div
                    *ngIf="
                      editAdminForm.get('email')?.hasError('required') &&
                      editAdminForm.get('email')?.touched
                    "
                  >
                    <small class="text-danger">Email is required.</small>
                  </div>
                  <div
                    *ngIf="
                      editAdminForm.get('email')?.hasError('invalidEmail') &&
                      editAdminForm.get('email')?.touched
                    "
                  >
                    <small class="text-danger">Invalid email format.</small>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label>Phone Number</label>
                  <input
                    formControlName="phoneNumber"
                    type="text"
                    class="form-control"
                    placeholder="Mobile Number"
                    readonly
                  />
                  <div
                    *ngIf="
                      editAdminForm.get('phoneNumber')?.hasError('required')
                    "
                  >
                    <small class="text-danger">Mobile Number is required</small>
                  </div>
                  <div
                    *ngIf="
                      editAdminForm
                        .get('phoneNumber')
                        ?.hasError('invalidPhoneNumber')
                    "
                  >
                    <small class="text-danger"
                      >Invalid phone number format</small
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label>Address</label>
                  <input
                    formControlName="address"
                    type="text"
                    class="form-control"
                    placeholder="5, xxxxx, Estate..."
                  />
                  <div
                    *ngIf="
                      editAdminForm.get('address')?.hasError('required') &&
                      editAdminForm.get('address')?.touched
                    "
                  >
                    <small class="text-danger">Address is required.</small>
                  </div>
                </div>
              </div>
            </div>

            <hr />

            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label>Select Tax Group</label>

                  <select
                    class="form-select"
                    formControlName="tax_group"
                    (change)="getDepartments($event)"
                  >
                    <!-- <option value="">{{ userDetails?.taxGroupName | removeUnderscores | uppercase}}</option> -->
                    <option
                      *ngFor="let taxgroup of taxgroups"
                      [value]="taxgroup"
                    >
                      {{ taxgroup | removeUnderscores | uppercase }}
                    </option>
                  </select>

                  <div
                    *ngIf="
                      editAdminForm.get('tax_group')?.hasError('required') &&
                      editAdminForm.get('tax_group')?.touched
                    "
                  >
                    <small class="text-danger">Tax Group is required.</small>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label>Select Role</label>

                  <select class="form-select" formControlName="role">
                    <option [value]="role?.id" *ngFor="let role of roles">
                      {{ role?.name | removeUnderscores | titlecase }}
                    </option>
                  </select>

                  <div
                    *ngIf="
                      editAdminForm.get('role')?.hasError('required') &&
                      editAdminForm.get('role')?.touched
                    "
                  >
                    <small class="text-danger">Role is required.</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label>Select Department</label>

                  <select class="form-select" formControlName="department">
                    <option value="">Select Department</option>
                    <option
                      [value]="department?.id"
                      *ngFor="let department of departmentList"
                    >
                      {{ department?.name | removeUnderscores | titlecase }}
                    </option>
                  </select>

                  <div
                    *ngIf="
                      editAdminForm.get('department')?.hasError('required') &&
                      editAdminForm.get('department')?.touched
                    "
                  >
                    <small class="text-danger">Department is required.</small>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label>Select Zone</label>

                  <select
                    class="form-select"
                    formControlName="zone"
                    (change)="getTaxOffice($event)"
                  >
                    <option value="">Select Zone</option>
                    <option [value]="zone?.id" *ngFor="let zone of zones">
                      {{ zone?.name | removeUnderscores | titlecase }}
                    </option>
                  </select>
                  <div
                    *ngIf="
                      editAdminForm.get('zone')?.hasError('required') &&
                      editAdminForm.get('zone')?.touched
                    "
                  >
                    <small class="text-danger">Zone is required.</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label>Select Tax Office</label>

                  <select class="form-select" formControlName="taxOffice">
                    <option value="">Select Tax Office</option>
                    <option
                      [value]="taxOffice?.id"
                      *ngFor="let taxOffice of taxOffices"
                    >
                      {{ taxOffice?.name | removeUnderscores | titlecase }}
                    </option>
                  </select>

                  <div
                    *ngIf="
                      editAdminForm.get('taxOffice')?.hasError('required') &&
                      editAdminForm.get('taxOffice')?.touched
                    "
                  >
                    <small class="text-danger">Zone is required.</small>
                  </div>
                  <small class="text-muted">
                    Select a zone to get tax office
                  </small>
                </div>
              </div>
            </div>
          </div>
        </form>

        <!-- ADMIN S
        TOPS HERE -->

        <form
          *ngIf="
            taxGroupSelected != 'COMPANY' &&
            taxGroupSelected != 'INFORMAL' &&
            taxGroupSelected != 'MDA'
          "
          class="row personal-form"
          [formGroup]="editNonCompanyForm"
        >
          <div class="col-md-6">
            <div class="form-group mb-2">
              <label>First Name <span class="text-danger">*</span></label>
              <input
                formControlName="firstName"
                type="text"
                class="form-control"
                placeholder="First Name"
                readonly
              />
              <div
                *ngIf="
                  editNonCompanyForm.get('firstName')?.hasError('required') &&
                  editNonCompanyForm.get('firstName')?.touched
                "
              >
                <small class="text-danger">First name is required.</small>
              </div>
            </div>

            <div class="row">
              <div class="col-md-5">
                <div class="form-group mt-2">
                  <label>Gender</label>
                  <select class="form-control" formControlName="gender">
                    <option default>
                      {{ userDetails?.gender | uppercase }}
                    </option>
                    <!-- <option value="MALE">Male</option>
                                    <option value="FEMALE">Female</option> -->
                  </select>
                </div>
              </div>
              <div class="col-md-7">
                <div class="form-group mb-2">
                  <label>Date of Birth</label>
                  <input
                    formControlName="dob"
                    value="{{ userDetails?.dob }}"
                    type="date"
                    class="form-control"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="form-group mb-2">
              <label>Email <span class="text-danger">*</span></label>
              <input
                formControlName="email"
                type="email"
                class="form-control"
                placeholder="axxxxx@gmail.com"
                readonly
              />
              <div
                *ngIf="
                  editNonCompanyForm.get('email')?.hasError('required') &&
                  editNonCompanyForm.get('email')?.touched
                "
              >
                <small class="text-danger">Email is required.</small>
              </div>
              <div
                *ngIf="
                  editNonCompanyForm.get('email')?.hasError('invalidEmail') &&
                  editNonCompanyForm.get('email')?.touched
                "
              >
                <small class="text-danger">Invalid email format.</small>
              </div>
            </div>
            <div class="form-group mb-2">
              <label>Address <span class="text-danger">*</span></label>
              <input
                formControlName="address"
                type="text"
                class="form-control"
                placeholder="5, xxxxx, Estate..."
              />
              <div
                *ngIf="
                  editNonCompanyForm.get('address')?.hasError('required') &&
                  editNonCompanyForm.get('address')?.touched
                "
              >
                <small class="text-danger">Address is required.</small>
              </div>
            </div>

            <div class="form-group mb-2">
              <label>NIN <span class="text-danger">*</span></label>
              <input
                formControlName="nin"
                type="text"
                class="form-control"
                placeholder="32xxxxxxxxxxx"
              />
              <div
                *ngIf="
                  editNonCompanyForm.get('nin')?.hasError('required') &&
                  editNonCompanyForm.get('nin')?.touched
                "
              >
                <small class="text-danger"> NIN is required.</small>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-2">
              <label>Last name <span class="text-danger">*</span></label>
              <input
                formControlName="lastName"
                type="text"
                class="form-control"
                placeholder="Last name"
                readonly
              />
              <div
                *ngIf="
                  editNonCompanyForm.get('lastName')?.hasError('required') &&
                  editNonCompanyForm.get('lastName')?.touched
                "
              >
                <small class="text-danger">Last Name is required.</small>
              </div>
            </div>
            <div class="form-group mb-2">
              <label>Mobile Number <span class="text-danger">*</span></label>
              <input
                formControlName="phoneNumber"
                type="text"
                class="form-control"
                placeholder="Mobile Number"
                readonly
              />
              <div
                *ngIf="
                  editNonCompanyForm.get('phoneNumber')?.hasError('required')
                "
              >
                <small class="text-danger">Mobile Number is required</small>
              </div>
              <div
                *ngIf="
                  editNonCompanyForm
                    .get('phoneNumber')
                    ?.hasError('invalidPhoneNumber')
                "
              >
                <small class="text-danger">Invalid phone number format</small>
              </div>
            </div>
            <div class="form-group mt-3">
              <label>LGA</label>
              <select class="form-control" formControlName="lgaId">
                <option default>{{ userDetails?.lgaName | uppercase }}</option>
                <option [value]="lga?.id" *ngFor="let lga of lgaList">
                  {{ lga?.name }}
                </option>
              </select>
            </div>
            <div class="form-group mt-4 mb-4">
              <label>Occupation</label>
              <select class="form-control" formControlName="occupationId">
                <option default>
                  {{ userDetails?.occupation | uppercase }}
                </option>
                <option
                  [value]="occupation?.id"
                  *ngFor="let occupation of occupationList"
                >
                  {{ occupation?.name }}
                </option>
              </select>
            </div>
            <div class="form-group mt-4">
              <label>Marital Status</label>
              <select class="form-control" formControlName="maritalStatus">
                <option default>{{ userDetails?.maritalStatus }}</option>
                <option value="DIVORCED">Divorced</option>
                <option value="MARRIED">Married</option>
                <option value="SINGLE">Single</option>
                <option value="WIDOWED">Widowed</option>
              </select>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          *ngIf="
            taxGroupSelected != 'COMPANY' &&
            taxGroupSelected != 'INFORMAL' &&
            taxGroupSelected != 'MDA'
          "
          type="submit"
          class="btn btn-outline-dark"
          [disabled]="!editNonCompanyForm.valid"
          (click)="confirmEdit()"
        >
          Save
        </button>
        <button
          *ngIf="
            taxGroupSelected == 'COMPANY' || taxGroupSelected == 'INFORMAL'
          "
          type="submit"
          class="btn btn-outline-dark"
          [disabled]="!editCompanyForm.valid"
          (click)="confirmCompanyEdit()"
        >
          Save
        </button>

        <button
          *ngIf="taxGroupSelected == 'MDA'"
          type="submit"
          class="btn btn-outline-dark"
          [disabled]="!editAdminForm.valid"
          (click)="confirmAdminEdit()"
        >
          Save
        </button>
      </div>
    </ng-template>

    <ng-template #reset_password_modal let-c="close" let-r="dismiss">
      <div class="modal-header">
        <h6>Reset {{ userDisplayName }}'s Password</h6>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="r('Close click'); reset()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div *ngIf="!passwordMatch" class="alert alert-danger text-center">
          <span>Passwords does not match</span>
        </div>
        <form [formGroup]="resetPasswordForm">
          <div class="mb-2">
            <label for="newPassword" class="form-label"
              >New Password <span class="text-danger">*</span></label
            >
            <input
              type="{{ showPassword }}"
              class="form-control"
              id="newPassword"
              formControlName="newPassword"
              #newPasswordInput
            />
            <div
              *ngIf="
                resetPasswordForm.get('newPassword')?.hasError('required') &&
                resetPasswordForm.get('newPassword')?.touched
              "
            >
              <small class="text-danger">Password is required.</small>
            </div>
            <div
              *ngIf="
                resetPasswordForm.get('newPassword')?.hasError('minlength') &&
                resetPasswordForm.get('newPassword')?.touched
              "
            >
              <small class="text-danger"
                >Password must be at least 8 characters long.</small
              >
            </div>
            <div
              *ngIf="
                resetPasswordForm
                  .get('newPassword')
                  ?.hasError('passwordRequirements') &&
                resetPasswordForm.get('newPassword')?.touched
              "
            >
              <small class="text-danger"
                >Password must contain at least one lowercase letter, one
                uppercase letter, one number, and one special symbol.</small
              >
            </div>
          </div>
          <div class="mb-2">
            <label for="confirmPassword" class="form-label"
              >Confirm Password <span class="text-danger">*</span></label
            >
            <input
              type="{{ showPassword }}"
              class="form-control"
              id="confirmPassword"
              formControlName="confirmPassword"
              #confirmPasswordInput
            />
            <div
              *ngIf="
                resetPasswordForm
                  .get('confirmPassword')
                  ?.hasError('required') &&
                resetPasswordForm.get('confirmPassword')?.touched
              "
            >
              <small class="text-danger">Password is required.</small>
            </div>
            <div
              *ngIf="
                resetPasswordForm
                  .get('confirmPassword')
                  ?.hasError('minlength') &&
                resetPasswordForm.get('confirmPassword')?.touched
              "
            >
              <small class="text-danger"
                >Password must be at least 8 characters long.</small
              >
            </div>
            <div
              *ngIf="
                resetPasswordForm
                  .get('confirmPassword')
                  ?.hasError('passwordRequirements') &&
                resetPasswordForm.get('confirmPassword')?.touched
              "
            >
              <small class="text-danger"
                >Password must contain at least one lowercase letter, one
                uppercase letter, one number, and one special symbol.</small
              >
            </div>
          </div>
          <div class="mb-2">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="showPassword"
                (click)="togglePassword()"
              />
              <label class="form-check-label" for="showPassword"
                >Show Password</label
              >
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <div class="mb-2">
          <button
            type="button"
            class="btn btn-dark btn-block"
            [disabled]="!resetPasswordForm.valid"
            (click)="confirmReset()"
          >
            Reset
          </button>
        </div>
      </div>
    </ng-template>
  </div>
</div>
<!-- <div style="position: sticky !important; bottom: 0 !important"> -->
<div>
  <app-footer *ngIf="hasAccess(['ADMIN'])" class="m-hidden"></app-footer>
  <app-mda-footer *ngIf="hasAccess(['MDA'])" class="m-hidden"></app-mda-footer>
</div>
